require('../../modules/es7.string.trim-right');
module.exports = require('../../modules/_core').String.trimRight;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/node_modules/core-js/fn/string/trim-end.js
// module id = 874
// module chunks = 196